<template>
  <v-app class="schrift">
    <v-layout style="overflow:hidden">

      <!-- HEADER -->
      <v-app-bar color="white" elevation="2">
        <v-app-bar-nav-icon @click="drawer = !drawer">
          <v-icon color="black">mdi-menu</v-icon>
        </v-app-bar-nav-icon>

        <!-- LOGO -->
        <router-link to="/">
          <v-img
            :src="SecLogo"
            class="logo-img no-hover-logo"
            contain
          />
        </router-link>

        <link href="https://fonts.cdnfonts.com/css/old-english-text-mt" rel="stylesheet">
        <v-toolbar-title class="toolbar-title"></v-toolbar-title>
      </v-app-bar>

      <!-- SIDEBAR -->
      <v-navigation-drawer v-model="drawer" temporary width="300">
        <v-card class="profile-card">

          <div class="avatar-bg">
            <v-img
              :src="hintergrundavatar"
              width="500px"
              class="no-hover-logo"
              cover
            />
          </div>

          <div class="d-flex justify-center avatar-wrapper">
            <v-avatar size="150" class="avatar no-hover-logo">
              <v-img :src="avatarmarc" class="no-hover-logo" />
            </v-avatar>
          </div>

          <v-card-title class="text-center mt-4">
            Marc Alexander Keil
          </v-card-title>

          <v-card-subtitle class="text-center mx-auto subtitle-black">
            <p>IT Anwendungsentwickler</p>
            <p>&</p>
            <p>Hilfsmittelberater</p>
          </v-card-subtitle>

          <v-card-actions class="justify-center">
            <v-btn variant="plain" class="icon-btn-card" to="/ueber-mich">
              <img :src="AboutMeIcon" class="icon-img-native-card" />
            </v-btn>

            <v-btn variant="plain" class="icon-btn-card" href="mailto:marcalexanderkeil@digitalbrückebymarc.de">
              <img :src="EmailIcon" class="icon-img-native-card" />
            </v-btn>

            <v-btn variant="plain" class="icon-btn-card" href="tel:+4917624669975">
              <img :src="TelephonIcon" class="icon-img-native-card" />
            </v-btn>

            <v-btn variant="plain" class="icon-btn-card" href="https://wa.me/4917624669975" target="_blank">
              <img :src="WhatsAppIcon" class="icon-img-native-card" />
            </v-btn>
          </v-card-actions>

        </v-card>

        <!-- NAVIGATION -->
        <v-list density="compact" nav>

          <v-list-item to="/" title="Startseite">
            <template #prepend>
              <img :src="HomeIcon" width="70px" />
            </template>
          </v-list-item>

          <v-list-group value="dienstleistungen">
            <template #activator="{ props }">
              <v-list-item v-bind="props" title="IT-Dienstleistungen">
                <template #prepend>
                  <img :src="ITDienstIcon" width="70px" />
                </template>
              </v-list-item>
            </template>

            <v-list-item to="/webdesign-wetzlar">
              <template #prepend>
                <img :src="DevelopIcon" width="70px" />
              </template>
              Webseiten Developing
            </v-list-item>

            <v-list-item to="/it-hilfe-wetzlar">
              <template #prepend>
                <img :src="AccessiIcon" width="70px" />
              </template>
              Senioren Hilfsmittelberatung
            </v-list-item>

            <v-list-item to="/android-hilfe">
              <template #prepend>
                <img :src="AndroidIcon" width="70px" />
              </template>
              Android Hilfsmittelberatung
            </v-list-item>

            <v-list-item to="/apple-hilfe">
              <template #prepend>
                <img :src="AppleIcon" width="70px" />
              </template>
              Apple Hilfsmittelberatung
            </v-list-item>

            <v-list-item to="/heimnetzwerk-einrichten">
              <template #prepend>
                <img :src="NetIcon" width="70px" />
              </template>
              Heimnetzwerk
            </v-list-item>

            <v-list-item to="/neuigkeiten">
              <template #prepend>
                <img :src="NewsIcon" width="70px" />
              </template>
              Neuigkeiten
            </v-list-item>
          </v-list-group>

          <v-list-item to="/leistungen">
            <template #prepend>
              <img :src="ITOfferIcon" width="70px" />
            </template>
            Angebotsübersicht
          </v-list-item>

          <v-list-item to="/it-wissen">
            <template #prepend>
              <img :src="ITWissenIcon" width="70px" />
            </template>
            Wissenswertes
          </v-list-item>

          <v-list-item to="/webinare-it-schulungen">
            <template #prepend>
              <img :src="WebinareIcon" width="70px" />
            </template>
            Webinare zu digitalen Hilfsmitteln
          </v-list-item>

          <v-list-item to="/partner">
            <template #prepend>
              <img :src="PartnerIcon" width="70px" />
            </template>
            Projekte & Partner
          </v-list-item>

        </v-list>

        <v-divider class="my-4" />
      </v-navigation-drawer>

      <!-- CONTENT -->
      <v-main>
        <router-view />
      </v-main>

    </v-layout>

    <!-- FOOTER -->
    <v-footer>
      <v-container class="text-center footer-border">

        <div class="text-h6 mb-2 font-weight-bold schrift">
          Erreichbarkeit
        </div>

        <div class="icon-row">
          <v-btn variant="plain" class="icon-btn" href="mailto:info@digitalbrückebymarc.de">
            <img :src="EmailIcon" class="icon-img-native" />
          </v-btn>

          <v-btn variant="plain" class="icon-btn" href="tel:+4917624669975">
            <img :src="TelephonIcon" class="icon-img-native" />
          </v-btn>

          <v-btn variant="plain" class="icon-btn" href="https://wa.me/4917624669975" target="_blank">
            <img :src="WhatsAppIcon" class="icon-img-native" />
          </v-btn>

          <v-btn variant="plain" class="icon-btn" href="whatsapp://send?text=Besuch%20https://www.digitalbrückebymarc.de">
            <img :src="ShareIcon" class="icon-img-native" />
          </v-btn>

          <v-btn variant="plain" class="icon-btn" href="https://www.instagram.com/marcalexanderberneaud/" target="_blank">
            <img :src="InstagramIcon" class="icon-img-native" />
          </v-btn>

          <v-btn variant="plain" class="icon-btn" to="/impressum">
            <img :src="ImpressumIcon" class="icon-img-native" />
          </v-btn>
        </div>

        <v-divider class="my-3" />

        <div>
          <strong>{{ new Date().getFullYear() }}</strong>
        </div>

        <v-icon>mdi-copyright</v-icon>
        <strong>Copyrights by Marc Alexander Keil</strong>

      </v-container>
    </v-footer>

  </v-app>
</template>

<script setup>
import { ref } from "vue"

import hintergrundavatar from "./assets/ITBackGr.jpg"
import avatarmarc from "./assets/AvatarProfil.png"

import EmailIcon from "./assets/MailIcon.png"
import TelephonIcon from "./assets/TelephonIcon.png"
import WhatsAppIcon from "./assets/WhatsAppIcon.png"
import InstagramIcon from "./assets/InstaIcon.png"
import ImpressumIcon from "./assets/InfoIcon.png"
import SecLogo from "./assets/LogoStart.png"

import AppleIcon from "./assets/AppleIcon.png"
import AndroidIcon from "./assets/Android2.png"
import NetIcon from "./assets/NetIcon2.png"
import NewsIcon from "./assets/NewsIcon.png"
import DevelopIcon from "./assets/DevelopIcon.png"
import AccessiIcon from "./assets/SeniorenIcon.png"
import ITOfferIcon from "./assets/ITOfferIcon.png"
import ITDienstIcon from "./assets/ITDienstIcon.png"
import ITWissenIcon from "./assets/ITWissenIcon.png"
import HomeIcon from "./assets/HomeIcon.png"
import WebinareIcon from "./assets/WebinarIcon.png"
import PartnerIcon from "./assets/PartnerIcon.png"
import ShareIcon from "./assets/ShareIcon.png"
import AboutMeIcon from "./assets/InfoAva.png"

const drawer = ref(false)

</script>

<style scoped>

.avatar{
margin-top: -50px;
margin-right: 100;
border:4px solid RGB(0, 102, 153);
color: black;
}

.v-card {
background-color:  rgb(204, 230, 255);
color: black;
}

.subtitle-black p {
  color: black!important;
  margin: 0;
  
}

.profile-card {
  position: relative;
  overflow: hidden;
  color: black;
}

/* Hintergrund exakt hinter Avatar */
.avatar-bg {
  top: 50px; /* feinjustierbar */
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0.65; /* Transparenz */
  border-radius: 50%;
  z-index: 1;
  position: absolute;
  width: 300px;
  top: 61px;

}

/* Avatar oben drauf */
.avatar-wrapper {
  position: relative;
  z-index: 2;
  margin-top: 60px;
}

.v-navigation-drawer {
  background-color: rgb(204, 230, 255);
  color: black; /* ✅ FIXED */
}

.toolbar-title {
  font-family: "Arial", serif;
  font-size: 25px;
  color: black;
  font-weight:bold;
}

</style>

<style>
.background{
font-family: "Arial", serif;
background-color: RGB(255, 255, 255); /* hellgrauer Hintergrund */
min-height:100vh;
color: black; /* kompletter Text schwarz */
}

.v-list{
font-family: "Arial", serif;
background-color:  rgb(223, 230, 228)!important;
color: black;
}


.schrift {
  font-family: "Georgia", serif;
  color: black;
}

.footer-border {
  border-top: 4px solid RGB(0, 102, 153);
  ;
}

.v-footer {
  font-family: "Arial", serif;
  background-color:  rgb(223, 230, 228);
  color: black
}

.v-toolbar {
  background-color: rgb(223, 230, 228);
  color: black;
}

/* Layout für Icons */
.icon-row {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1px;
  flex-wrap: wrap;
}

/* Button Größe */
.icon-btn {
  width: 100px;
  height: 100px;
  padding: 0;
}

/* Bild im Button */
.icon-img-native {
  width: 100px;
  object-fit: contain;
}

/* Optional schöner Hover Effekt */
.icon-btn:hover {
  transform: scale(1.1);
  transition: 0.1s;
}

/* Button Größe */
.icon-btn-card {
  width: 70px;
  height: 100px;
  padding: 0;
}

/* Bild im Button */
.icon-img-native-card {
  width: 130px;
  object-fit: contain;
}

.logo-wrapper {
  height: 200px;              /* gleiche Höhe wie Toolbar */
  display: flex;
  
}

.logo-img {
  height: 100px;              /* 🔥 hier stellst du die Größe ein */
  width: 240px;
}

.no-hover-logo:hover {
  transform: none !important;
}
</style>